module.exports = __webpack_public_path__ + "img/improved-citizen-safety.e37550aa.svg";